module.exports = __webpack_public_path__ + "static/media/pp_clear_bendable_straw2.54146c48.png";